// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
  display: flex;
}

.tabs li {
  position: relative;
  display: block;
  padding: 10px 40px;
  margin-right: 12px;
  cursor: pointer;

  border-radius: 5px 5px 0px 0px;
  border: none;
  border-bottom: 0.5pt solid #1d1e22;
  display: inline-flex;
  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.25);
  background: #1c1b1b;
  color: #ccc;
}

@media (width < 1025px) {
  .tabs li {
    padding: 10px 20px;
    margin-right: 12px;
  }
}

@media (width < 700px) {
  .tabs li {
    padding: 5px 15px;
    margin-right: 5px;
    font-size: 14px;
  }
}

@media (width < 500px) {
  .tabs li {
    padding: 5px 10px;
    margin-right: 5px;
    font-size: 12px;
  }

  .tabs {
    margin-left: -35px;
  }
}

.tabs li.active {
  color: deepskyblue;
}

.tabs li.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;

  background-image: linear-gradient(
    113deg,
    hsl(260deg 100% 64%) 0%,
    hsl(190deg 100% 55%) 100%
  );
}

.tab_content {
  padding: 30px;
  border-radius: 5px;
  min-height: 190px;
  margin: -16px 12% 0% 0%;
  background: #1c1b1b;
  box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.25);
}

.filters {
  font-family: "Ubuntu";
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.stile-input {
  font-family: Ubuntu;
  border-radius: 5px 0px 0px 5px;
  background-color: #212121 !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
  color: #cccc;
  text-align: center;
  height: 35px;
  width: 200px;
}

.stile-input::placeholder {
  font-family: Ubuntu;
  color: #cccccc5d;
  width: 200px;
}

.stile-html::placeholder {
  font-family: Ubuntu;
  color: #eeeeee;
}
.cursor-data {
  cursor:  default;
}

.calendar-container {
  font-family: Ubuntu;
  position: relative;
}
.calendar-container:focus,
.calendar-container:active
{outline: none;}
.react-calendar {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
}

.calend {
  color: #fff;
  background: #001767;
  border-radius: 5px;
  border: none;
  z-index: 100;
  height: 35px;
}

.search {
  width: 40px;
}

.ban-button {
  padding: 5px 10px;
  width: 70%;
  cursor: pointer;
  border: none;
  border-radius: 2px;
  font-size: 14px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.not-banned {
  background-color: #3837375d;
  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.25);
  color: #ccc;
}

.banned {
  background-color: #5cb85c;
  color: #fff;
}

.ban-button:hover {
  background-color: #d9534f;
  color: #fff;
}

.buttonDelete {
  font-size: 20px;
  width: 10%;
  margin: 0.2vh 15% 0 0;
  color: #bf2554;
}
.buttonEdit {
  font-size: 18px;
  width: 8%;
  /* line-height: 2px; */
  padding: 0;
  margin: 0.2vh .0vh 0 0.0vh;
  color: #ebce2c;
}
.buttonDelete:hover {
  font-size: 24px;
  transition: 0s;
}
.buttonCheck {
  font-size: 18px;
  /* line-height: 2px; */
  margin: 0.2vh 5% 0 0;
  color: #21aa0f;
}
.buttonDelete:hover {
  font-size: 24px;
  transition: 0s;
}
.butDelete {
  font-family: Ubuntu;
  border-radius: 5px;
  background: rgba(229, 42, 16, 0.74);
  color: #ffff;
  border: none;
  width: 240px;
  height: 35px;
}

.position-stile-modal {
  display: flex;
  justify-content: flex-end;
  right: 0px;
}

.filters-position {
  justify-content: end;
  margin-bottom: 20px;
}

.journal-table-position {
  display: flex;
  justify-content: space-around;
  gap: 50px;
}

@media (width < 500px) {
  .journal-table-position {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 25px;
  }

  .position-stile-modal {
    display: flex;
    justify-content: flex-start;
  }
}

.th-padding {
  margin: 0px 0vh;
  width: auto;
  max-width:5vh;
  padding: 0;
}
.th-padding-auto {
  margin: 0px 0vh;
  padding: 0;
  width: 17vh;
}

.th-padding-index {
  margin: 0px 0vh;
  width: 7vh;
 
  padding: 0;
}
@media (width < 900px) {
  .filters {
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: start;
  }
}

@media (width < 700px) {
  .filters {
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/bots/laundry/Tabs/tabs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;;EAEf,8BAA8B;EAC9B,YAAY;EACZ,kCAAkC;EAClC,oBAAoB;EACpB,+CAA+C;EAC/C,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;;EAEX;;;;GAIC;AACH;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,oCAAoC;EACpC,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;CAEC,aAAa,CAAC;AACf;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,UAAU;EACV,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,2BAA2B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,UAAU;AACZ;AACA;EACE,eAAe;EACf,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,UAAU;;EAEV,UAAU;AACZ;AACA;EACE;IACE,eAAe;IACf,sBAAsB;IACtB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;IACtB,sBAAsB;EACxB;AACF","sourcesContent":[".tabs {\n  display: flex;\n}\n\n.tabs li {\n  position: relative;\n  display: block;\n  padding: 10px 40px;\n  margin-right: 12px;\n  cursor: pointer;\n\n  border-radius: 5px 5px 0px 0px;\n  border: none;\n  border-bottom: 0.5pt solid #1d1e22;\n  display: inline-flex;\n  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.25);\n  background: #1c1b1b;\n  color: #ccc;\n}\n\n@media (width < 1025px) {\n  .tabs li {\n    padding: 10px 20px;\n    margin-right: 12px;\n  }\n}\n\n@media (width < 700px) {\n  .tabs li {\n    padding: 5px 15px;\n    margin-right: 5px;\n    font-size: 14px;\n  }\n}\n\n@media (width < 500px) {\n  .tabs li {\n    padding: 5px 10px;\n    margin-right: 5px;\n    font-size: 12px;\n  }\n\n  .tabs {\n    margin-left: -35px;\n  }\n}\n\n.tabs li.active {\n  color: deepskyblue;\n}\n\n.tabs li.active::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n\n  background-image: linear-gradient(\n    113deg,\n    hsl(260deg 100% 64%) 0%,\n    hsl(190deg 100% 55%) 100%\n  );\n}\n\n.tab_content {\n  padding: 30px;\n  border-radius: 5px;\n  min-height: 190px;\n  margin: -16px 12% 0% 0%;\n  background: #1c1b1b;\n  box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.25);\n}\n\n.filters {\n  font-family: \"Ubuntu\";\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.stile-input {\n  font-family: Ubuntu;\n  border-radius: 5px 0px 0px 5px;\n  background-color: #212121 !important;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;\n  color: #cccc;\n  text-align: center;\n  height: 35px;\n  width: 200px;\n}\n\n.stile-input::placeholder {\n  font-family: Ubuntu;\n  color: #cccccc5d;\n  width: 200px;\n}\n\n.stile-html::placeholder {\n  font-family: Ubuntu;\n  color: #eeeeee;\n}\n.cursor-data {\n  cursor:  default;\n}\n\n.calendar-container {\n  font-family: Ubuntu;\n  position: relative;\n}\n.calendar-container:focus,\n.calendar-container:active\n{outline: none;}\n.react-calendar {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n}\n\n.calend {\n  color: #fff;\n  background: #001767;\n  border-radius: 5px;\n  border: none;\n  z-index: 100;\n  height: 35px;\n}\n\n.search {\n  width: 40px;\n}\n\n.ban-button {\n  padding: 5px 10px;\n  width: 70%;\n  cursor: pointer;\n  border: none;\n  border-radius: 2px;\n  font-size: 14px;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.not-banned {\n  background-color: #3837375d;\n  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.25);\n  color: #ccc;\n}\n\n.banned {\n  background-color: #5cb85c;\n  color: #fff;\n}\n\n.ban-button:hover {\n  background-color: #d9534f;\n  color: #fff;\n}\n\n.buttonDelete {\n  font-size: 20px;\n  width: 10%;\n  margin: 0.2vh 15% 0 0;\n  color: #bf2554;\n}\n.buttonEdit {\n  font-size: 18px;\n  width: 8%;\n  /* line-height: 2px; */\n  padding: 0;\n  margin: 0.2vh .0vh 0 0.0vh;\n  color: #ebce2c;\n}\n.buttonDelete:hover {\n  font-size: 24px;\n  transition: 0s;\n}\n.buttonCheck {\n  font-size: 18px;\n  /* line-height: 2px; */\n  margin: 0.2vh 5% 0 0;\n  color: #21aa0f;\n}\n.buttonDelete:hover {\n  font-size: 24px;\n  transition: 0s;\n}\n.butDelete {\n  font-family: Ubuntu;\n  border-radius: 5px;\n  background: rgba(229, 42, 16, 0.74);\n  color: #ffff;\n  border: none;\n  width: 240px;\n  height: 35px;\n}\n\n.position-stile-modal {\n  display: flex;\n  justify-content: flex-end;\n  right: 0px;\n}\n\n.filters-position {\n  justify-content: end;\n  margin-bottom: 20px;\n}\n\n.journal-table-position {\n  display: flex;\n  justify-content: space-around;\n  gap: 50px;\n}\n\n@media (width < 500px) {\n  .journal-table-position {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    gap: 25px;\n  }\n\n  .position-stile-modal {\n    display: flex;\n    justify-content: flex-start;\n  }\n}\n\n.th-padding {\n  margin: 0px 0vh;\n  width: auto;\n  max-width:5vh;\n  padding: 0;\n}\n.th-padding-auto {\n  margin: 0px 0vh;\n  padding: 0;\n  width: 17vh;\n}\n\n.th-padding-index {\n  margin: 0px 0vh;\n  width: 7vh;\n \n  padding: 0;\n}\n@media (width < 900px) {\n  .filters {\n    flex-wrap: wrap;\n    flex-direction: column;\n    justify-content: start;\n  }\n}\n\n@media (width < 700px) {\n  .filters {\n    flex-wrap: wrap;\n    flex-direction: column;\n    justify-content: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
